import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/merchant-apply',
    name: 'MerchantApply',
    component: () => import('../views/MerchantApply.vue'),
    meta: { requiresAuth: false, title: '球房入驻申请' }
  },
  {
    path: '/screen/room-ranking',
    name: 'RoomRankingScreen',
    component: () => import('../views/screen/RoomRankingScreen.vue'),
    meta: { requiresAuth: false, title: '球房榜大屏' }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'House', requiresAuth: true }
      },

      // ===== 系统管理 =====
      {
        path: 'system/user',
        name: 'UserList',
        component: () => import('../views/system/UserList.vue'),
        meta: { title: '用户管理', requiresAuth: true }
      },
      {
        path: 'system/role',
        name: 'RoleList',
        component: () => import('../views/system/RoleList.vue'),
        meta: { title: '角色管理', requiresAuth: true }
      },
      {
        path: 'system/menu',
        name: 'MenuList',
        component: () => import('../views/system/MenuList.vue'),
        meta: { title: '菜单管理', requiresAuth: true }
      },

      // ===== B端-商户管理 =====
      {
        path: 'merchant/dashboard',
        name: 'MerchantDashboard',
        component: () => import('../views/merchant/Dashboard.vue'),
        meta: { title: '商户概览', icon: 'DataBoard', requiresAuth: true }
      },
      {
        path: 'merchant/orders',
        name: 'MerchantOrders',
        component: () => import('../views/merchant/OrderList.vue'),
        meta: { title: '预约订单', icon: 'List', requiresAuth: true }
      },
      {
        path: 'merchant/tables',
        name: 'MerchantTables',
        component: () => import('../views/merchant/TableList.vue'),
        meta: { title: '球台管理', icon: 'Grid', requiresAuth: true }
      },
      {
        path: 'merchant/coaches',
        name: 'MerchantCoaches',
        component: () => import('../views/merchant/CoachList.vue'),
        meta: { title: '助教管理', icon: 'User', requiresAuth: true }
      },
      {
        path: 'merchant/events',
        name: 'MerchantEvents',
        component: () => import('../views/merchant/EventList.vue'),
        meta: { title: '赛事申请', icon: 'Trophy', requiresAuth: true }
      },
      {
        path: 'merchant/battles',
        name: 'MerchantBattles',
        component: () => import('../views/merchant/BattleList.vue'),
        meta: { title: '约战订单', icon: 'Connection', requiresAuth: true }
      },
      {
        path: 'merchant/staff',
        name: 'MerchantStaff',
        component: () => import('../views/merchant/StaffList.vue'),
        meta: { title: '员工管理', icon: 'UserFilled', requiresAuth: true }
      },
      {
        path: 'merchant/room-members',
        name: 'MerchantRoomMembers',
        component: () => import('../views/merchant/RoomMemberList.vue'),
        meta: { title: '球房成员', icon: 'Avatar', requiresAuth: true }
      },
      {
        path: '/screen/room-leaderboard',
        name: 'RoomLeaderboardScreen',
        component: () => import('../views/screen/index.vue'),
        meta: { requiresAuth: false, title: '球房榜单' }
      },


      {
        path: 'merchant/stats',
        name: 'MerchantStats',
        component: () => import('../views/merchant/Stats.vue'),
        meta: { title: '经营统计', icon: 'DataAnalysis', requiresAuth: true }
      },
      {
        path: 'merchant/settings',
        name: 'MerchantSettings',
        component: () => import('../views/merchant/Settings.vue'),
        meta: { title: '球房设置', icon: 'Setting', requiresAuth: true }
      },
      {
        path: 'merchant/jobs',
        name: 'MerchantJobs',
        component: () => import('../views/merchant/JobList.vue'),
        meta: { title: '招聘管理', icon: 'Briefcase', requiresAuth: true }
      },
      {
        path: 'merchant/verify',
        name: 'MerchantVerify',
        component: () => import('../views/merchant/VerifyList.vue'),
        meta: { title: '核销管理', icon: 'Select', requiresAuth: true }
      },

      // ===== P端-平台管理 =====
      {
        path: 'platform/dashboard',
        name: 'PlatformDashboard',
        component: () => import('../views/platform/Dashboard.vue'),
        meta: { title: '平台概览', icon: 'DataBoard', requiresAuth: true }
      },
      {
        path: 'platform/members',
        name: 'PlatformMembers',
        component: () => import('../views/platform/MemberList.vue'),
        meta: { title: '会员管理', icon: 'User', requiresAuth: true }
      },
      {
        path: 'platform/merchants',
        name: 'PlatformMerchants',
        component: () => import('../views/platform/MerchantList.vue'),
        meta: { title: '商户管理', icon: 'OfficeBuilding', requiresAuth: true }
      },
      {
        path: 'platform/events',
        name: 'PlatformEvents',
        component: () => import('../views/platform/EventList.vue'),
        meta: { title: '赛事管理', icon: 'Trophy', requiresAuth: true }
      },
      {
        path: 'platform/events/:eventId/arrange',
        name: 'EventArrange',
        component: () => import('../views/platform/EventArrange.vue'),
        meta: { title: '赛事编排', requiresAuth: true }
      },
      {
        path: 'platform/battles',
        name: 'PlatformBattles',
        component: () => import('../views/platform/BattleList.vue'),
        meta: { title: '约战管理', icon: 'Connection', requiresAuth: true }
      },
      {
        path: 'platform/disputes',
        name: 'PlatformDisputes',
        component: () => import('../views/platform/DisputeList.vue'),
        meta: { title: '争议管理', icon: 'Warning', requiresAuth: true }
      },
      {
        path: 'platform/mall',
        name: 'PlatformMall',
        component: () => import('../views/platform/MallList.vue'),
        meta: { title: '积分商城', icon: 'ShoppingCart', requiresAuth: true }
      },
      {
        path: 'platform/mall-orders',
        name: 'PlatformMallOrders',
        component: () => import('../views/platform/MallOrderList.vue'),
        meta: { title: '商城订单', icon: 'List', requiresAuth: true }
      },
      {
        path: 'platform/coupons',
        name: 'PlatformCoupons',
        component: () => import('../views/platform/CouponList.vue'),
        meta: { title: '优惠券管理', icon: 'Ticket', requiresAuth: true }
      },
      {
        path: 'platform/content',
        name: 'PlatformContent',
        component: () => import('../views/platform/ContentList.vue'),
        meta: { title: '内容管理', icon: 'Document', requiresAuth: true }
      },
      {
        path: 'platform/banners',
        name: 'PlatformBanners',
        component: () => import('../views/platform/BannerList.vue'),
        meta: { title: 'Banner管理', icon: 'Picture', requiresAuth: true }
      },
      {
        path: 'platform/jobs',
        name: 'PlatformJobs',
        component: () => import('../views/platform/JobList.vue'),
        meta: { title: '招聘审核', icon: 'Briefcase', requiresAuth: true }
      },
      {
        path: 'platform/config',
        name: 'PlatformConfig',
        component: () => import('../views/platform/ConfigList.vue'),
        meta: { title: '系统配置', icon: 'Tools', requiresAuth: true }
      },
      {
        path: 'platform/rank-level',
        name: 'PlatformRankLevel',
        component: () => import('../views/platform/RankLevelList.vue'),
        meta: { title: '段位配置', icon: 'Medal', requiresAuth: true }
      },
      {
        path: 'platform/coaches',
        name: 'PlatformCoaches',
        component: () => import('../views/platform/CoachList.vue'),
        meta: { title: '教练管理', icon: 'Avatar', requiresAuth: true }
      },

      {
        path: 'platform/forum',
        name: 'PlatformForum',
        component: () => import('../views/platform/ForumList.vue'),
        meta: { title: '论坛管理', icon: 'ChatDotRound', requiresAuth: true }
      },
      {
        path: 'platform/teaching',
        name: 'PlatformTeaching',
        component: () => import('../views/platform/TeachingList.vue'),
        meta: { title: '教学管理', icon: 'VideoCamera', requiresAuth: true }
      },
      {
        path: 'platform/teaching/form',
        name: 'PlatformTeachingForm',
        component: () => import('../views/platform/TeachingForm.vue'),
        meta: { title: '课程编辑', requiresAuth: true }
      },
      {
        path: 'platform/feedback',
        name: 'PlatformFeedback',
        component: () => import('../views/platform/FeedbackList.vue'),
        meta: { title: '意见反馈', icon: 'ChatLineSquare', requiresAuth: true }
      },

      // ===== 详情页 =====
      {
        path: 'platform/mall-orders/:id',
        name: 'PlatformMallOrderDetail',
        component: () => import('../views/platform/MallOrderDetail.vue'),
        meta: { title: '订单详情', requiresAuth: true }
      },
      {
        path: 'platform/merchants/:id',
        name: 'PlatformMerchantDetail',
        component: () => import('../views/platform/MerchantDetail.vue'),
        meta: { title: '商户详情', requiresAuth: true }
      },
      {
        path: 'platform/members/:id',
        name: 'PlatformMemberDetail',
        component: () => import('../views/platform/MemberDetail.vue'),
        meta: { title: '会员详情', requiresAuth: true }
      },
      {
        path: 'platform/jobs/:id',
        name: 'PlatformJobDetail',
        component: () => import('../views/platform/JobDetail.vue'),
        meta: { title: '招聘详情', requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.meta.requiresAuth !== false

  if (to.path === '/login') {
    if (token) {
      next('/')
      return
    }
    next()
    return
  }

  if (requiresAuth && !token) {
    next('/login')
    return
  }

  const title = to.meta.title
  if (title) {
    document.title = `${title} - 十三档管理平台`
  } else {
    document.title = '十三档管理平台'
  }

  next()
})

export default router
